// @ts-nocheck
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import DataTable, { DataTableProps } from "@insite/mobius/DataTable";
import DataTableBody from "@insite/mobius/DataTable/DataTableBody";
import DataTableCell from "@insite/mobius/DataTable/DataTableCell";
import DataTableHead from "@insite/mobius/DataTable/DataTableHead";
import DataTableHeader from "@insite/mobius/DataTable/DataTableHeader";
import DataTableRow from "@insite/mobius/DataTable/DataTableRow";
import { StyleguideSection } from "@store/Library/Components/Toolkit/Styleguide/ui";
import React, { FC } from "react";
import { css } from "styled-components";

const wrapperCss = css`
    overflow-x: auto;
`;

const StyleguideDataTables: FC<DataTableProps> = () => {
    return (
        <StyleguideSection title="DataTable">
            <StyledWrapper css={wrapperCss}>
                <DataTable>
                    <DataTableHead>
                        <DataTableHeader>Row</DataTableHeader>
                        <DataTableHeader>Item #</DataTableHeader>
                        <DataTableHeader>QTY</DataTableHeader>
                        <DataTableHeader>U/M</DataTableHeader>
                        <DataTableHeader>Reason</DataTableHeader>
                    </DataTableHead>
                    <DataTableBody>
                        <DataTableRow>
                            <DataTableCell>Lorem</DataTableCell>
                            <DataTableCell>Ipsum</DataTableCell>
                            <DataTableCell>Dolor</DataTableCell>
                            <DataTableCell>Sit</DataTableCell>
                            <DataTableCell>Amet</DataTableCell>
                        </DataTableRow>
                        <DataTableRow>
                            <DataTableCell>Amet</DataTableCell>
                            <DataTableCell>Sit</DataTableCell>
                            <DataTableCell>Dolor</DataTableCell>
                            <DataTableCell>Ipsum</DataTableCell>
                            <DataTableCell>Lorem</DataTableCell>
                        </DataTableRow>
                        <DataTableRow>
                            <DataTableCell>Sit</DataTableCell>
                            <DataTableCell>Amet</DataTableCell>
                            <DataTableCell>Lorem</DataTableCell>
                            <DataTableCell>Dolor</DataTableCell>
                            <DataTableCell>Ipsum</DataTableCell>
                        </DataTableRow>
                    </DataTableBody>
                </DataTable>
            </StyledWrapper>
        </StyleguideSection>
    );
};

export default StyleguideDataTables;
